import React, { useState } from "react";

function TodoList({ todos, updateTodo, deleteTodo, getError }) {
  const [editId, setEditId] = useState(-1);
  const [editTitle, setEditTitle] = useState("");
  const [editDesc, setEditDesc] = useState("");
  const [fieldError,setFieldError] = useState("")

  function onEdit(data) {
    setEditId(data._id);
    setEditTitle(data.title);
    setEditDesc(data.description);
  }

  return (
    <>
      {getError ? (
        <>
          <h2 className="text-danger text-center">Unable to fetch items !</h2>
          <p className="text-center">Backend Error</p>
        </>
      ) : (
        <>
          {todos.length === 0 ? (
            <>
              <h2 className="text-secondary text-center">
                There are no Tasks available
              </h2>
            </>
          ) : (
            <>
              {todos &&
                todos.map((data, i) => (
                  <li
                    key={i}
                    className="bg-info list-group-item d-flex justify-content-between align-items-center"
                  >
                    {editId === data._id ? (
                      <div className="col">
                        <div className="d-flex flex-column flex-sm-row justify-content-between col">
                          <div className="d-sm-flex gap-2 mb-2 col">
                            <input
                              type="text"
                              placeholder="Title"
                              value={editTitle}
                              onChange={(e) => setEditTitle(e.target.value)}
                              className="form-control mt-2"
                            />
                            <input
                              type="text"
                              placeholder="Description"
                              value={editDesc}
                              onChange={(e) => setEditDesc(e.target.value)}
                              className="form-control mt-2"
                            />
                          </div>
                          <div className="d-flex gap-2 ms-2 mb-2">
                            <button
                              className="btn btn-sm btn-success mt-2"
                              onClick={() => {
                                if (editTitle.trim() !== '' && editDesc.trim() !== '') {
                                  updateTodo(data._id, editTitle, editDesc);
                                  setEditId(-1);
                                  setFieldError('');
                                  setEditTitle('');
                                  setEditDesc('');
                                }
                                else{
                                  setFieldError("Values should not be empty");
                                  setTimeout(()=>setFieldError(''),3000)
                                }
                              }}
                            >
                              Update
                            </button>
                            <button
                              className="btn btn-sm btn-secondary mt-2"
                              onClick={() => setEditId(-1)}
                            >
                              Cancel
                            </button>
                          </div>
                          </div>
                        {fieldError?(<p className="text-danger fw-bold">{fieldError}</p>):(<></>)}
                      </div>
                    ) : (
                      <>
                        <div className="d-flex flex-column">
                          <span className="fw-bold">{data.title}</span>
                          <span>{data.description}</span>
                        </div>
                        <div className="d-flex gap-2">
                          <button
                            className="btn btn-sm btn-warning"
                            onClick={() => onEdit(data)}
                          >
                            Edit
                          </button>
                          <button
                            className="btn btn-sm btn-danger"
                            data-bs-target={`#modalDelete${i}`}
                            data-bs-toggle="modal"
                          >
                            Delete
                          </button>
                          <div
                            className="modal fade"
                            data-bs-backdrop="static"
                            id={`modalDelete${i}`}
                            tabIndex="-1"
                          >
                            <div className="modal-dialog modal-dialog-centered">
                              <div className="modal-content bg-dark">
                                <div className="modal-body">
                                  <p className="text-white">
                                    Are you sure you want to delete?
                                  </p>
                                </div>
                                <div className="modal-footer">
                                  <button
                                    type="button"
                                    className="btn btn-primary"
                                    data-bs-dismiss="modal"
                                  >
                                    NO
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={() => deleteTodo(data._id)}
                                    data-bs-dismiss="modal"
                                  >
                                    Delete
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </li>
                ))}
            </>
          )}
        </>
      )}
    </>
  );
}

export default TodoList;
